<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-07-30 16:00:29
-->
<template>
  <van-tabbar v-model="active" class="tabbar" fixed safe-area-inset-bottom>
    <van-tabbar-item
      v-for="(item, index) in tabList"
      :key="index"
      route
      :icon="item.icon"
      :to="item.to"
    >
      <span>{{ item.name }}</span>
      <template #icon="props">
        <img :src="props.active ? item.active : item.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
const tabList = [
  {
    name: '首页',
    icon: 'home-o',
    active: require('@/assets/common/tabbar_home_icon_active.png'),
    inactive: require('@/assets/common/tabbar_home_icon.png'),
    to: '/index',
  },
  {
    name: '课程商城',
    active: require('@/assets/common/tabbar_shop_icon_active.png'),
    inactive: require('@/assets/common/tabbar_shop_icon.png'),
    to: '/course',
  },
  {
    name: '学堂',
    active: require('@/assets/common/tabbar_college_icon_active.png'),
    inactive: require('@/assets/common/tabbar_college_icon.png'),
    to: '/college',
  },
  {
    name: '短视频',
    active: require('@/assets/common/tabbar_video_icon_active.png'),
    inactive: require('@/assets/common/tabbar_video_icon.png'),
    to: '/video',
  },
  {
    name: '学习中心',
    active: require('@/assets/common/tabbar_study_icon_active.png'),
    inactive: require('@/assets/common/tabbar_study_icon.png'),
    to: '/study',
  },
]
export default {
  name: 'Tabbar',
  data() {
    return {
      active: 0,
      tabList,
    }
  },
  watch: {
    $route() {
      const routePath = this.$route.path
      this.active = tabList.findIndex(item => routePath.indexOf(item.to) == 0)
    },
  },
  created() {
    const routePath = this.$route.path
    this.active = tabList.findIndex(item => routePath.indexOf(item.to) == 0)
  },
}
</script>
<style lang="scss" scoped>
.tabbar {
  z-index: 3000;
  width: 100%;
  height: 98px;
  background: #ffffff;
  box-shadow: 0px -6px 10px 0px rgba(201, 201, 201, 0.3);
  &::after {
    display: none;
  }
  .van-tabbar-item__icon {
    img {
      height: 48px;
    }
  }
  .van-tabbar-item__text {
    font-size: 22px;
  }
  .van-tabbar-item {
    color: #666;
    &--active {
      color: #ff7b33;
    }
  }
}
</style>
